<footer>
  <div class="footer-content">
    <img src="assets/AZ_logo.svg" alt="AZ" class="footer-logo" />
    <p class="footer-description">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus aliquid
      quibusdam debitis nisi, quis exercitationem ex quaerat est corporis,
      cupiditate cumque sapiente animi unde? Voluptas fugiat quam quas quis
      deleniti.
    </p>
  </div>
  <br />
  <p class="footer-version">
    {{ applicationName }} Version: {{ applicationVersion }} AstraZeneca
    {{ copyrightYear }}
  </p>
</footer>
